import { apiClient } from './client';
import { extractItemsFromResponse, handleApiError } from './utils';

export const fetchUsersByRole = async ({ userRole }) => {
    if (!userRole) {
        return [];
    }

    try {
        const response = await apiClient.get('/user', {
            params: { page: 1, pageSize: 1000, userRole }
        });

        return extractItemsFromResponse(response.data);
    } catch (error) {
        handleApiError(error, 'Personel listesi alınırken bir hata oluştu.');
        return [];
    }
};
